import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import './Shipping.css';
import BoxesImage from './Assets/boxes.jpg';
import { hasRoleAccess } from './utils/roles'; // Import role-checking helper

const Shipping = ({ userRole }) => {
  const [todayCount, setTodayCount] = useState(0);
  const [last7DaysCount, setLast7DaysCount] = useState(0);
  const [lastMonthCount, setLastMonthCount] = useState(0);
  const [prev7DaysCount, setPrev7DaysCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { instance, accounts } = useMsal();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (accounts.length > 0) {
      fetchShipmentStats();
    } else {
      // No account found, end loading state.
      setLoading(false);
    }
  }, [accounts]);

  const fetchShipmentStats = async () => {
    try {
      const tokenResponse = await instance.acquireTokenSilent({
        scopes: ["https://database.windows.net/.default"],
        account: accounts[0]
      });
      const response = await axios.get(`${apiBaseUrl}/api/shipment-stats`, {
        headers: { Authorization: `Bearer ${tokenResponse.accessToken}` }
      });
      const data = response.data;
      setTodayCount(data.today || 0);
      setLast7DaysCount(data.last7Days || 0);
      setLastMonthCount(data.lastMonth || 0);
      setPrev7DaysCount(data.prev7Days || 0);
    } catch (error) {
      console.error("Error fetching shipment stats:", error);
    } finally {
      setLoading(false);
    }
  };

  // Compare last 7 days vs. previous 7 days
  const difference = last7DaysCount - prev7DaysCount;
  let differenceIndicator = null;
  if (difference > 0) {
    differenceIndicator = (
      <span style={{ color: 'green', marginLeft: '8px' }}>
        &uarr; {difference}
      </span>
    );
  } else if (difference < 0) {
    differenceIndicator = (
      <span style={{ color: 'red', marginLeft: '8px' }}>
        &darr; {Math.abs(difference)}
      </span>
    );
  }

  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="shipping-container">
      <div className="banner-container-shipping">
        <img src={BoxesImage} alt="Boxes" className="banner-image-shipping" />
        <div className="banner-text">Shipping and Receiving</div>
      </div>

      <div className="shipment-stats">
        {/* TODAY Card */}
        <div className="stat-card">
          <h3>Today</h3>
          <p>
            <span className="count-number">{todayCount}</span>
            <span className="count-label"> Shipments</span>
          </p>
        </div>

        {/* LAST 7 DAYS Card */}
        <div className="stat-card">
          <h3>Last 7 Days</h3>
          <p>
            <span className="count-number">
              {difference !== 0 && (
                <span className={`diff-indicator ${difference > 0 ? 'positive' : 'negative'}`}>
                  {difference > 0 ? '↑' : '↓'}
                </span>
              )}
              {last7DaysCount}
            </span>
            <span className="count-label"> Shipments</span>
          </p>
        </div>

        {/* LAST MONTH Card */}
        <div className="stat-card">
          <h3>Last Month</h3>
          <p>
            <span className="count-number">{lastMonthCount}</span>
            <span className="count-label"> Shipments</span>
          </p>
        </div>
      </div>

      <hr className="separator" />

      <div className="section">
        <h2>Database Views</h2>
        <div className="quick-views-container">
          <Link to="/shipping-items" className="link-button">
            <button className="shipping-button">Open Database View</button>
          </Link>
        </div>
      </div>

      <div className="section">
        <h2>Quick Actions</h2>
        <div className="actions-container">
          {hasRoleAccess(userRole, 'shipping-create') && (
            <Link to="/create-shipping-item" className="link-button">
              <button className="shipping-button action-button">Create Shipping Item</button>
            </Link>
          )}
          {hasRoleAccess(userRole, 'location-create') && (
            <Link to="/create-location-entry" className="link-button">
              <button className="shipping-button action-button">Add Location Entry</button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shipping;
